import {abtest_SubscribePopupVariants, IListItem} from '../../list-page/interfaces/interfaces';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import {getABTest, sendABTestAnalytics} from "../../../domain/abtest/abtest-provider";

interface IProductSubscriptionTiersTextABTEST {
    product: IListItem,
    className?: string,
    subscribePopupVariants:abtest_SubscribePopupVariants | undefined;
    returnFunc?: Function,
}

const ProductSubscriptionTiersTextABTEST = (props: IProductSubscriptionTiersTextABTEST) => {

    const { product, className } = props;

    const url = `/subscriptions?skus=${ product.skuid }`;

    const sendGoogleEvents = () => {
        sendGAEvent('Subscribe', product.documentName);

        const abtest_SubscribePopup = getABTest('SubscribePopup');
        sendABTestAnalytics(abtest_SubscribePopup);

        if (props?.subscribePopupVariants === abtest_SubscribePopupVariants.popup && props?.returnFunc) {
            props?.returnFunc();
        }
    };

    const alsoIncludedText = product.skuNumber === 'WGEMS' ? 'Included' : 'Also included';

    return (
        <div className={ `text-sm mt-4 ${ className || '' }` } data-grid-sbs-text="true">
             {props?.subscribePopupVariants === abtest_SubscribePopupVariants.sbs_page &&
                <>
                {
                    product.sbsIncludedIn === 1 &&
                    <span>{ alsoIncludedText } in Waves Ultimate: <a href={ url } className="underline" onClick={ sendGoogleEvents }>Subscribe</a></span>
                }

                {
                    product.sbsIncludedIn === 2 &&
                    <span>{ alsoIncludedText } in Waves Essential & Ultimate: <a href={ url } className="underline" onClick={ sendGoogleEvents }>Subscribe</a></span>
                }

                {
                    !product.sbsIncludedIn && <span>&nbsp;</span>
                }
                </>
            }
            {props?.subscribePopupVariants === abtest_SubscribePopupVariants.popup &&
                <>
                    {
                        product.sbsIncludedIn === 1 &&
                        <span>{ alsoIncludedText } in Waves Ultimate: <button type="button" className="underline text-blue-200" onClick={ sendGoogleEvents }>Subscribe</button></span>
                    }

                    {
                        product.sbsIncludedIn === 2 &&
                        <span>{ alsoIncludedText } in Waves Essential & Ultimate: <button type="button" className="underline text-blue-200" onClick={ sendGoogleEvents }>Subscribe</button></span>
                    }

                    {
                        !product.sbsIncludedIn && <span>&nbsp;</span>
                    }
                </>
            }
        </div>
    )
};

export default ProductSubscriptionTiersTextABTEST;